export default __webpack_public_path__ + "static/media/poigne-de-main1.3e36b6e2.png";